import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Spin, Typography, Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import shaka from 'shaka-player/dist/shaka-player.ui.js';
import 'shaka-player/dist/controls.css';
import './ReplayPlayer.scss';

import { byteliveGetPlaybackUrl } from '../../../../modules/bytelive';

const { Text } = Typography;

class ReplayPlayer extends Component {
  state = {
    playbackUrl: null,
    loading: false,
    error: null,
  };

  videoRef = React.createRef();
  player = null;

  componentDidMount() {
    this.initPlayer();
    this.fetchPlaybackUrl();
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.destroy();
      this.player = null;
    }
  }

  initPlayer() {
    shaka.polyfill.installAll();
    if (!shaka.Player.isBrowserSupported()) {
      this.setState({ error: 'Browser not supported for video playback' });
      return;
    }
    this.player = new shaka.Player(this.videoRef.current);
    this.player.addEventListener('error', this.onPlayerError);
  }

  fetchPlaybackUrl = async () => {
    const { replay, byteliveGetPlaybackUrl } = this.props;
    if (!replay) return;
    this.setState({ loading: true, error: null });
    try {
      const response = await byteliveGetPlaybackUrl({
        contentId: replay.contentId,
        contentType: 'LiveReplay',
      });
      const url = response?.media?.hls?.url;
      if (!url) throw new Error('Invalid playback URL response');
      this.setState({ playbackUrl: url, loading: false });
      await this.loadVideo(url);
    } catch (err) {
      console.error('Failed to load playback URL:', err);
      this.setState({ error: 'Failed to load video', loading: false });
    }
  };

  loadVideo = async (url) => {
    if (!this.player) return;
    try {
      await this.player.load(url);
      this.videoRef.current.play().catch(() => {});
    } catch (err) {
      console.error('Failed to load video:', err);
      this.setState({ error: 'Failed to load video stream' });
    }
  };

  onPlayerError = (event) => {
    const { detail } = event;
    console.error('Shaka error', detail);
    this.setState({ error: detail?.message || 'Video error' });
  };

  render() {
    const { replay, onClose } = this.props;
    const { loading, error } = this.state;
    if (!replay) return null;

    return (
      <Card
        className="replay-player"
        title={replay.title}
        extra={<Button icon={<CloseOutlined />} onClick={onClose} type="text" size="small" />}
        bodyStyle={{ padding: 0 }}
      >
        <div className="video-wrapper">
          <video ref={this.videoRef} className="replay-video" controls />
          {loading && (
            <div className="loading-overlay">
              <Spin size="large" />
            </div>
          )}
          {error && (
            <div className="error-message">
              <Text type="danger">{error}</Text>
            </div>
          )}
        </div>
      </Card>
    );
  }
}

const mapStateToProps = state => ({
  router: state.router,
  userProfile: state.user.userProfile,
  selectedOrganization: state.user.selectedOrganization,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ byteliveGetPlaybackUrl }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ReplayPlayer);
